function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleMyPageRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29.038 24a13.995 13.995 0 00-4.339-2.738.494.494 0 01-.17-.794c1.208-1.31 1.495-2.229 1.495-4.968 0-3.5-2.01-5.5-5.024-5.5-3.014 0-5.023 2-5.023 5.5 0 2.66.287 3.641 1.5 4.97a.492.492 0 01-.173.79A14.003 14.003 0 0012.963 24c-.648.645-.878 2.294-.96 3.882A2.008 2.008 0 0014.005 30h13.988a2.006 2.006 0 002.003-2.117c-.081-1.59-.31-3.238-.959-3.883zM14 27.985c-.02-.89.122-1.777.422-2.615a12.34 12.34 0 013.645-2.26 2.493 2.493 0 00.887-3.987c-.726-.796-.977-1.195-.977-3.623 0-1.596.524-3.5 3.022-3.5 2.498 0 3.025 1.904 3.025 3.5 0 2.456-.216 2.8-.966 3.614a2.493 2.493 0 00.878 3.997c1.337.534 2.57 1.299 3.642 2.259.3.844.44 1.735.416 2.63L14 27.985zM17 7H6v2h11V7zM14 11H6v2h8v-2zM11 15H6v2h5v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v4h2V4a2 2 0 00-2-2H4a2 2 0 00-2 2v18a2 2 0 002 2h6v-2H4V4z",
    fill: props.color
  }));
}

export default SvgIconPeopleMyPageRexOutline;